import { Component, inject, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { DomainService } from 'services/domain.service';
import { NavigationService } from 'services/navigation.service';
import { Inputs } from 'modules/inputs';
import { DomainModel } from 'models/generated/Distribution.Api.Models.Domain';
import { NewDomainProductPlanInputComponent } from './new-domain-product-plan-input.component';

@Component({
	templateUrl: './new-domain-product-plan.component.html',
	imports: [FormsModule, Layout, Inputs, TranslatePipe, NewDomainProductPlanInputComponent]
})
export class NewDomainProductPlanComponent {

	@Input() domain?: DomainModel;
	@ViewChild(NewDomainProductPlanInputComponent) newProductPlan?: NewDomainProductPlanInputComponent;

	private readonly navigation = inject(NavigationService);
	private readonly domainService = inject(DomainService);

	canConfirm() {
		return !!this.domain && this.newProductPlan?.isValid;
	}

	async confirm() {
		if (!this.domain?.id || !this.newProductPlan?.selectedVariant?.id || !this.newProductPlan?.brandId || !this.newProductPlan?.isValid) return;

		await this.domainService.createNewDomainProductPlan(this.domain.id, this.newProductPlan.selectedVariant.id, this.newProductPlan.brandId, this.newProductPlan?.price);
		this.close();
	}

	close() {
		this.navigation.closeView(this);
	}
}
